import { Link } from "react-router-dom";
import { COMPANY_NAME, COMPANY_TAGLINE, companyStats } from "@/mocks/company";

export default function BrandIntro() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10 items-center">
          <div className="lg:col-span-5 relative">
            <div className="w-full aspect-[4/5] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20an%20empty%20art%20house%20screening%20room%20with%20warm%20amber%20projector%20light%20beam%20and%20deep%20navy%20velvet%20seats%2C%20minimal%20elegant%20composition%2C%20soft%20haze%2C%20high%20detail&width=900&height=1125&seq=home-brand-intro&orientation=portrait"
                alt="星光传媒主题放映空间"
                title="星光传媒放映空间"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-accent-500 rounded-lg px-4 py-3 md:px-5 md:py-4">
              <p className="font-heading text-2xl md:text-3xl font-semibold text-primary-950 leading-none">12</p>
              <p className="text-[11px] md:text-xs text-primary-950/80 mt-1">年专注于影视内容</p>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-6">
            <span className="text-xs tracking-[0.22em] uppercase text-secondary-600">About Starlight</span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 mt-2 mb-4 leading-tight">
              我们相信，好电影
              <br className="hidden md:block" />
              值得被认真介绍一次
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              {COMPANY_TAGLINE}。{COMPANY_NAME}
              从一间 28 座的小放映室起步，如今已经成为一个覆盖电影、剧集与资讯的内容机构。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              我们不追逐单一口味的热度，而是以“是否值得看完”为标准建立推荐体系。每一部作品都经过编辑初筛、内容解读与观众反馈三轮评估。
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mb-7">
              {companyStats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-background-300 pl-3">
                  <p className="font-heading text-xl md:text-2xl font-semibold text-primary-700 leading-none">{stat.value}</p>
                  <p className="text-xs md:text-sm text-foreground-800 mt-1.5">{stat.label}</p>
                  <p className="text-[11px] text-foreground-400 mt-0.5">{stat.description}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多关于星光
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}